import { getAllFreshSeedBag, getFreshSeedBag , getAllFreshSeedBagOptions } from "@/api/fresh_seed_bag";

const state = {
    freshSeedBags: null,
    freshSeedBagDetail: null,
    freshSeedBagOptions: null
};

const mutations = {
    GET_ALL: (state, data) => {
        state.freshSeedBags = data;
    },
    GET_DETAIL: (state, data) => {
        state.freshSeedBagDetail = data;
    },
    GET_OPTIONS: (state, data) => {
        state.freshSeedBagOptions = data;
    },
};

const actions = {
    async getAllFreshSeedBag({ commit }, notificationPagination) {
        let res = await getAllFreshSeedBag({ ...notificationPagination });
        if (res) {
            commit("GET_ALL", res); 
        }
    },
    async getFreshSeedBag({ commit }, params) {
        let res = await getFreshSeedBag(params);
        if (res) {
            commit("GET_DETAIL", res); 
        }
    },
    async getAllFreshSeedBagOptions({ commit }, params) {
        let res = await getAllFreshSeedBagOptions(params);
        if (res) {
            commit("GET_OPTIONS", res); 
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};




// WEBPACK FOOTER //
// ./src/vuex/modules/fresh_seed_bag.js